export function Theme90sFooter() {
  return (
    <div className="theme-90s-footer theme-90s-ornament">
      <div style={{ flex: 1 }} />
      <div style={{ textAlign: 'center' }}>
        <div style={{ color: '#FFFF00', fontWeight: 'bold', fontSize: 12 }}>
          © 1996 - 2026 FAIRMINT, INC. ALL RIGHTS RESERVED.
        </div>
        <div style={{ color: '#CCCCFF', fontSize: 10, marginTop: 3 }}>
          Site crafted by hand with HTML 4.0 and a lot of caffeine ☕
        </div>
      </div>
      <div className="theme-90s-footer-row">
        <span className="theme-90s-counter">
          <span style={{ color: '#FFFF99' }}>You are visitor</span>
          <span className="theme-90s-counter-digits">000013</span>
          <span className="theme-90s-counter-digits">37</span>
        </span>
      </div>
    </div>
  );
}
